<script lang="ts" setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';

interface Props {
  from?: number;
  to: number;
  duration?: number;
  decimals?: number;
}

const props = withDefaults(defineProps<Props>(), {
  from: 0,
  to: 0,
  duration: 1000,
  decimals: 1,
});

const value = ref(props.from);
let observer: IntersectionObserver;
const container = ref();

const animate = () => {
  const TIMEOUT = 25;
  const numberOfAnimation = props.duration / TIMEOUT;
  const incrementOf = props.to / numberOfAnimation;

  for (let i = 0; i < numberOfAnimation; i += 1) {
    setTimeout(() => {
      value.value += incrementOf;
    }, TIMEOUT * i);
  }

  // This is the last animation
  setTimeout(() => {
    value.value = props.to;
  }, TIMEOUT * numberOfAnimation);
};

onMounted(() => {
  observer = new IntersectionObserver(
    (entries) => {
      const container = entries[0];
      if (container.isIntersecting === true) {
        animate();
        observer.unobserve(container.target); // Don't pass another time
      }
    },
    { threshold: [0.5] },
  );

  observer.observe(container.value);
});

onBeforeUnmount(() => {
  observer.disconnect();
});
</script>
<template>
  <div ref="container">
    <span>{{
      Number.isInteger(props.to) ? Math.floor(value) : value.toFixed(props.decimals)
    }}</span>
  </div>
</template>
